
























































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import {
  LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST,
  UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL
} from '@/store/action-types'
import { MasterDataActionsEnum, QcqOperations } from '@/types/enums'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'
import { GridOptions } from '@/types'
import TimeModelEditorDialog from '@/components/master-data/time-models/TimeModelEditorDialog.vue'
import { SimpleWeekTimeModelDialog } from '@/types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'

interface ComponentData {
  gridData: Array<SimpleWeekTimeModel>
  gridOptions: GridOptions
  operation: typeof QcqOperations
  openDialog: boolean
  currentSelectedRowId: string,
  currentSelectedTimeModel: SimpleWeekTimeModel | undefined
  currentSelectedOperation: number
  timeModelDialogData: SimpleWeekTimeModelDialog | undefined
  showErrorSnackbar: boolean
  errorMessage: string
  showSnackbar: boolean
  successMessage: string
  dialogLoading: boolean
  showDeleteDialog: boolean
  overlayNoRowsTemplate: string
  showSearchField: boolean
  search: string | null
  loading: boolean
}

export default Vue.extend({
  name: 'MasterDataPlanningDataPage',

  components: {
    AgGridVue,
    TimeModelEditorDialog,
    DeleteDialog,
    ProgressCircular
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.masterDataTimeModelsPage.code'), field: 'MOD_IDENT_NR', width: 100 },
          { headerName: this.$t('masterData.masterDataTimeModelsPage.name'), field: 'name', width: 200 },
          { headerName: this.$t('masterData.masterDataTimeModelsPage.type'), field: 'modelType', width: 100 },
          { headerName: this.$t('masterData.masterDataTimeModelsPage.ABW'), field: 'ABW', width: 160 },
          { headerName: this.$t('masterData.masterDataTimeModelsPage.KAL'), field: 'KAL', width: 160 },
          { headerName: this.$t('planningPage.monday'), field: 'monday', width: 125 },
          { headerName: this.$t('planningPage.tuesday'), field: 'tuesday', width: 125 },
          { headerName: this.$t('planningPage.wednesday'), field: 'wednesday', width: 125 },
          { headerName: this.$t('planningPage.thursday'), field: 'thursday', width: 125 },
          { headerName: this.$t('planningPage.friday'), field: 'friday', width: 125 },
          { headerName: this.$t('planningPage.saturday'), field: 'saturday', width: 122 },
          { headerName: this.$t('planningPage.sunday'), field: 'sunday', width: 125 }
        ]
      },
      operation: QcqOperations,
      openDialog: false,
      currentSelectedRowId: '',
      currentSelectedTimeModel: undefined,
      currentSelectedOperation: QcqOperations.ADD,
      timeModelDialogData: undefined,
      showErrorSnackbar: false,
      errorMessage: '',
      showSnackbar: false,
      successMessage: '',
      dialogLoading: false,
      showDeleteDialog: false,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      showSearchField: false,
      search: null,
      loading: false
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEditButtonDisabled (): boolean {
      if(this.currentSelectedTimeModel && this.currentSelectedTimeModel.modelType === 'S') {
        return false
      } else {
        return true
      }
    },

    isDeleteButtonDisabled (): boolean {
      return true
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): SimpleWeekTimeModel[] {
      if(this.search) {
        return this.gridData.filter((item: SimpleWeekTimeModel) => {
          return item.name.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    showDialog (operation: number): void {
      this.currentSelectedOperation = operation
      this.timeModelDialogData = {
        timestamp: new Date().getTime(),
        operation: operation,
        timeModel: this.currentSelectedTimeModel
      }
      this.openDialog = true
    },

    closeDialog (): void {
      this.openDialog = false
      this.showDeleteDialog = false
    },

    onDeleteButtonClick (): void {
      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.currentSelectedOperation = QcqOperations.REMOVE
      if (this.currentSelectedTimeModel) {
        const timeModel = new SimpleWeekTimeModel(
          this.currentSelectedTimeModel.id,
          this.currentSelectedTimeModel.name,
          this.createString(this.currentSelectedTimeModel.ABW!),
          this.createString(this.currentSelectedTimeModel.KAL!),
          this.currentSelectedTimeModel.MDT_IDENT_NR,
          this.currentSelectedTimeModel.MOD_IDENT_NR,
          this.createString(this.currentSelectedTimeModel.monday!),
            this.currentSelectedTimeModel.mondayFrom ? this.currentSelectedTimeModel.mondayFrom : null,
            this.currentSelectedTimeModel.mondayTo ? this.currentSelectedTimeModel.mondayTo : null,
          this.createString(this.currentSelectedTimeModel.tuesday!),
            this.currentSelectedTimeModel.tuesdayFrom ? this.currentSelectedTimeModel.tuesdayFrom : null,
            this.currentSelectedTimeModel.tuesdayTo ? this.currentSelectedTimeModel.tuesdayTo : null,
          this.createString(this.currentSelectedTimeModel.wednesday!),
            this.currentSelectedTimeModel.wednesdayFrom ? this.currentSelectedTimeModel.wednesdayFrom : null,
            this.currentSelectedTimeModel.wednesdayTo ? this.currentSelectedTimeModel.wednesdayTo : null,
          this.createString(this.currentSelectedTimeModel.thursday!),
            this.currentSelectedTimeModel.thursdayFrom ? this.currentSelectedTimeModel.thursdayFrom : null,
            this.currentSelectedTimeModel.thursdayTo ? this.currentSelectedTimeModel.thursdayTo : null,
          this.createString(this.currentSelectedTimeModel.friday!),
            this.currentSelectedTimeModel.fridayFrom ? this.currentSelectedTimeModel.fridayFrom : null,
            this.currentSelectedTimeModel.fridayTo ? this.currentSelectedTimeModel.fridayTo : null,
          this.createString(this.currentSelectedTimeModel.saturday!),
            this.currentSelectedTimeModel.saturdayFrom ? this.currentSelectedTimeModel.saturdayFrom : null,
            this.currentSelectedTimeModel.saturdayTo ? this.currentSelectedTimeModel.saturdayTo : null,
          this.createString(this.currentSelectedTimeModel.sunday!),
            this.currentSelectedTimeModel.sundayFrom ? this.currentSelectedTimeModel.sundayFrom : null,
            this.currentSelectedTimeModel.sundayTo ? this.currentSelectedTimeModel.sundayTo : null,
          this.currentSelectedTimeModel.validFrom!,
          this.currentSelectedTimeModel.modelType!
        )
        this.onSaveDialog(timeModel)
      }
    },

    createString (time: string): string {
      const h = time.split(':')[0]
      const m = time.split(':')[1]
      const minutes = (Number(h) * 60) + Number(m)
      return minutes.toString()
    },

    async onSaveDialog (timeModel: undefined | SimpleWeekTimeModel): Promise<void> {
      if (timeModel) {
        const map = new Map([
          [QcqOperations.ADD, MasterDataActionsEnum.Create],
          [QcqOperations.EDIT, MasterDataActionsEnum.Update],
          [QcqOperations.REMOVE, MasterDataActionsEnum.Delete]
        ])
        try {
          this.dialogLoading = true
          await this.$store.dispatch(UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL, {
            action: map.get(this.currentSelectedOperation),
            timeModel: timeModel
          })
          this.dialogLoading = false
          this.closeDialog()
          this.showSnackbar = true
          this.successMessage = this.$t('success.dataHaveBeenSaved').toString()
          this.currentSelectedTimeModel = undefined
        } catch (e) {
          this.dialogLoading = false
          this.errorMessage = this.$t('errors.dataCouldNotBeSaved').toString()
          this.showErrorSnackbar = true
        }
        const data = await this.$store.dispatch(LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST, { action: MasterDataActionsEnum.Read })
        this.gridData = data
      }
    },

    onRowDataChanged () {
      //@ts-ignore
      this.gridOptions.api.sizeColumnsToFit()
    },

    onRowClicked (params: any) {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedTimeModel = _.find(this.gridData, { id: this.currentSelectedRowId })
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    }
  },

  async created () {
    this.loading = true
    try {
      const data = await this.$store.dispatch(LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST, { action: MasterDataActionsEnum.Read })
      this.gridData = data
    } catch {

    } finally {
      this.loading = false
    }
  }
})
